import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '../lib/cn.ts'
import { badgeVariants, type BadgeVariants } from './Badge.variants.ts'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, BadgeVariants {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { className, tone, size, ...props },
  ref,
) {
  return <span ref={ref} className={cn(badgeVariants({ tone, size }), className)} {...props} />
})
